export default "__VITE_ASSET__zJSJR12D__"